<div class="layoutBlock">
    <div class="columnHalf">

        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationMeans' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationTrain"
                    type="checkbox" [(ngModel)]="transportation.transportationTrain"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationReservation"
                    type="checkbox" [(ngModel)]="transportation.transportationReservation" class="checkboxBeforeLabel"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationReservationExplanation"
                    class="textareaWidth100 expand" rows="1"
                    [disabled]="transportation.transportationReservation !== true"
                    [(ngModel)]="transportation.transportationReservationExplanation"
                    (ngModelChange)="onModelChange($event)"></textarea>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationPublicTransport"
                    type="checkbox" [(ngModel)]="transportation.transportationPublicTransport"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationMotorcycle"
                    type="checkbox" [(ngModel)]="transportation.transportationMotorcycle"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationBicycle"
                    type="checkbox" [(ngModel)]="transportation.transportationBicycle"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationAirplane"
                    type="checkbox" [(ngModel)]="transportation.transportationAirplane"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationRentalCar"
                    type="checkbox" [(ngModel)]="transportation.transportationRentalCar"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationLongDistanceBus"
                    type="checkbox" [(ngModel)]="transportation.transportationLongDistanceBus"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationCompanyCar"
                    type="checkbox" [(ngModel)]="transportation.transportationCompanyCar"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationOwnCar"
                    type="checkbox" [(ngModel)]="transportation.transportationOwnCar"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationOther"
                    type="checkbox" [(ngModel)]="transportation.transportationOther"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.transportationOtherExplanation"
                    class="textareaWidth100 expand" rows="1" [disabled]="transportation.transportationOther !== true"
                    [(ngModel)]="transportation.transportationOtherExplanation"
                    (ngModelChange)="onModelChange($event)"></textarea>
            </his-plam>
        </p-panel>

        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation' | hisUi}}"
            [toggleable]="false">
            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.smallMileageAllowance"
                    type="checkbox" [(ngModel)]="transportation.smallMileageAllowance"
                    (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.largeMileageAllowance"
                    type="checkbox" [(ngModel)]="transportation.largeMileageAllowance" (ngModelChange)="
                    onModelChange($event)" />
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.largeMileageAllowanceExplanation"
                    class="textareaWidth100 expand" rows="1" [disabled]="transportation.largeMileageAllowance !== true"
                    [(ngModel)]=" transportation.largeMileageAllowanceExplanation"
                    (ngModelChange)="onModelChange($event)"></textarea>
            </his-plam>
        </p-panel>
    </div>

    <div class="clearAndSpace"></div>

    <div class="columnHalf">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.privateTrip' | hisUi}}"
            [toggleable]="false">

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.privateTripCheckbox"
                    type="checkbox" [(ngModel)]="transportation.isPrivateTrip"
                    (ngModelChange)=" onModelChange($event)" />
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.privateTripBeginDate"
                    [(ngModel)]="transportation.privateTripBeginDate" [dateFormat]="dateTimeFormat" [showTime]="true"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [disabled]="transportation.isPrivateTrip !== true" [placeholder]="datePlaceholderFormat"
                    (ngModelChange)="onModelChange($event)">
                </p-calendar>
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.privateTripEndDate"
                    [(ngModel)]="transportation.privateTripEndDate" [dateFormat]="dateTimeFormat" [showTime]="true"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [disabled]="transportation.isPrivateTrip !== true" [placeholder]="datePlaceholderFormat"
                    (ngModelChange)="onModelChange($event)">
                </p-calendar>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.privateTripResidence"
                    class="inputWidth100" [(ngModel)]="transportation.privateTripResidence"
                    [disabled]="transportation.isPrivateTrip !== true" (ngModelChange)="onModelChange($event)" />
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.privateTripAddress"
                    class="textareaWidth100 expand" rows="1" [(ngModel)]="transportation.privateTripAddress"
                    [disabled]="transportation.isPrivateTrip !== true"
                    (ngModelChange)="onModelChange($event)"></textarea>
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation.privateTripExplanation"
                    class="textareaWidth100 expand" rows="1" [(ngModel)]="transportation.privateTripExplanation"
                    [disabled]="transportation.isPrivateTrip !== true"
                    (ngModelChange)="onModelChange($event)"></textarea>
            </his-plam>
        </p-panel>
    </div>
</div>